import React, { memo, useState } from 'react';
import { icons } from '~/assets';
import { useAuth } from '~/hooks/contexts/useAuth';
import { cnpjMask, cpfMask, IDefaultReturn } from '~/utils/masks';
import * as St from './styles';
import THEMES from '~/themes/themes';

// const OPTIONS: ITab[] = [
//   {
//     label: 'Cadastro',
//     url: '/register',
//   },
//   {
//     label: 'Consultar/Desativar usuário',
//     url: '/consult/disable',
//   },
// ];

// const NEW_TABS = [
//   ...TABS,
//   ...OPTIONS,
//   {
//     label: 'Sair',
//     onClick: () => console.log('kkk'),
//   },
// ];

const DefaultHeader: React.FC = () => {
  // const user = JSON.parse(localStorage.getItem('@NovaEra:user'));
  // const [menuIsOpen, setMenuIsOpen] = useState(false);
  const { signOut, user } = useAuth();

  const company = user?.companies?.[0];

  // const handleToggleMenu = useCallback(() => {
  //   setMenuIsOpen((prev) => !prev);
  // }, []);

  const handleLogout = () => signOut();

  return (
    <>
      <St.Container>
        <St.Logo src={icons.newLogo} />
        <div style={{ flexDirection: 'column' }}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              gap: '0.5rem',
            }}
          >
            <St.WrapperButtons>
              {/* <HeaderSelect label="Área logada" options={OPTIONS} /> */}

              <St.UserInfo>
                {`Usuário: ${
                  user?.cpf?.length > 4 ? cnpjMask(user?.cpf) : user?.cpf
                } - ${user?.nomeTitular}`}
              </St.UserInfo>
              <St.Logout onClick={handleLogout}>Sair</St.Logout>
            </St.WrapperButtons>
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center',
            }}
          >
            <span
              style={{
                fontSize: '0.8rem',
                color: `${THEMES.colors.primary}`,
                marginTop: '4px',
              }}
            >
              Versão: &nbsp;
              {process.env.REACT_APP_VERSAO_APP}
            </span>
          </div>
        </div>
      </St.Container>
      {/* <MenuSideBar
        open={menuIsOpen}
        handleClose={handleToggleMenu}
        tabs={NEW_TABS}
      /> */}
    </>
  );
};

export default memo(DefaultHeader);
